(function () {
  var params = new URLSearchParams(window.location.search);
  var productName = String(params.get('product') || '').trim();
  var productUrl = String(params.get('product_url') || '').trim();

  if (!productName && !productUrl) {
    return;
  }

  var productContext = [productName, productUrl].filter(Boolean).join(' — ');
  var attempts = 0;
  var maxAttempts = 40;

  function matchesProductField(value) {
    return /product[\s_-]*(name|title|url)|product_name_or_url/i.test(String(value || ''));
  }

  function findProductField(root) {
    if (!root || !root.querySelectorAll) {
      return null;
    }

    var fields = root.querySelectorAll('input, textarea');
    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      if (
        matchesProductField(field.name) ||
        matchesProductField(field.id) ||
        matchesProductField(field.getAttribute('aria-label')) ||
        matchesProductField(field.placeholder)
      ) {
        return field;
      }
    }

    var labels = root.querySelectorAll('label');
    for (var labelIndex = 0; labelIndex < labels.length; labelIndex += 1) {
      var label = labels[labelIndex];
      if (!matchesProductField(label.textContent)) {
        continue;
      }

      if (label.htmlFor) {
        var labelledField = root.querySelector('#' + CSS.escape(label.htmlFor));
        if (labelledField) {
          return labelledField;
        }
      }

      var nestedField = label.querySelector('input, textarea');
      if (nestedField) {
        return nestedField;
      }
    }

    var elements = root.querySelectorAll('*');
    for (var elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
      if (elements[elementIndex].shadowRoot) {
        var shadowField = findProductField(elements[elementIndex].shadowRoot);
        if (shadowField) {
          return shadowField;
        }
      }
    }

    return null;
  }

  function setFieldValue(field, value) {
    if (!field || field.value) {
      return false;
    }

    var prototype = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    var valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value');

    if (valueSetter && valueSetter.set) {
      valueSetter.set.call(field, value);
    } else {
      field.value = value;
    }

    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    return true;
  }

  function prefillProductContext() {
    attempts += 1;
    var field = findProductField(document);

    if (field && (setFieldValue(field, productContext) || field.value)) {
      return;
    }

    if (attempts < maxAttempts) {
      window.setTimeout(prefillProductContext, 250);
    }
  }

  prefillProductContext();
})();
